import React, { useContext } from "react";
import AuthContext from "../../store/auth-context";
import UserMenu from "../common/UserMenu";
import Notification from "../common/Notification";
import { useTranslation } from "react-i18next";
import RegisterdUsersInfo from "./RegisterdUsersInfo";
import DeletedUsersInfo from "./DeletedUsersInfo";
import InterestedUsersForOffres from "./InterestedUsersForOffres";

function AnalyticsDashboard() {
  const authCtx = useContext(AuthContext);
  const [t] = useTranslation();

  const openMobileMenu = (e: any) => {
    e.preventDefault();

    document.getElementById("leftMenu")?.classList.remove("d-none");
  };

  return (
    <div className="main-content animate py-4 px-3 px-sm-4">
      <div className="d-flex align-items-center mb-3">
        <a
          href="#"
          className="d-inline-block d-sm-none text-dark"
          onClick={(e) => openMobileMenu(e)}
        >
          <i className="material-icons-outlined me-2">menu</i>
        </a>
        <h3 className="fs-18-24">{t("Analytics")}</h3>
        <div
          className={`${
            authCtx.selectedLanguage === "en" ? "ms-auto" : "mr-auto"
          } mw-90px`}
        >
          <Notification />
          <UserMenu />
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12 col-lg-6 my-lg-0 my-2">
          <RegisterdUsersInfo />
        </div>
        <div className="col-sm-12 col-lg-6 my-lg-0 my-2">
          <DeletedUsersInfo />
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-sm-12 col-lg-6 my-lg-0 my-2">
          <InterestedUsersForOffres />
        </div>
      </div>
    </div>
  );
}

export default AnalyticsDashboard;
